import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import styles from './mobile-apps.styl'
import config from 'config'

import appStoreImage from 'assets/img/ic-appstore@2x.png'
import androidStoreImage from 'assets/img/ic-googleplay@2x.png'

export default class MobileApps extends Component {
  static propTypes = {
    isAwardStaff: PropTypes.bool
  }

  render() {
    const { isAwardStaff } = this.props
    const intlKey = isAwardStaff
      ? 'label.you_can_also_download_leader'
      : 'label.you_can_also_download_participant'

    const appStoreLink = isAwardStaff
      ? config.iosLeaderAppLink
      : config.iosAppLink

    const androidStoreLink = isAwardStaff
      ? config.androidLeaderAppLink
      : config.androidAppLink

    return (
      <div className={styles.apps}>

        <p className={styles.desc}>
          <FormattedHTMLMessage
            id={intlKey}
            defaultMessage="You can also download our brand new <strong>Participant app</strong> and access to Online Record Book anytime, anywhere."
          />
        </p>

        <div className={styles.badges}>
          <div className="row">
            <div className="col-xs-6 text--center">
              <a className={styles.link} target="_blank" href={appStoreLink}>
                <img
                  className={styles.img}
                  src={appStoreImage}
                  alt="App store badge"
                />
              </a>
              <span className={styles.for}>
                <FormattedMessage id="label.for_ios" defaultMessage="for iOS" />
              </span>
            </div>
            <div className="col-xs-6 text--center">
              <a
                className={styles.link}
                target="_blank"
                href={androidStoreLink}
              >
                <img
                  className={styles.img}
                  src={androidStoreImage}
                  alt="Google play badge"
                />
              </a>
              <span className={styles.for}>
                <FormattedMessage
                  id="label.for_android"
                  defaultMessage="for Android"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
